import { PerformantCampaignVariant } from 'modules/iterableGoals/types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { body1, body1Bold, body2, caption, colors, heading3, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p5: pxToRem(5),
  p48: pxToRem(48),
  p56: pxToRem(56),
};

type ContributionCountProps = {
  campaignVariant: PerformantCampaignVariant;
};

type ThumbnailWrapperProps = {
  isThumbnailAvailable: boolean;
};

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubText = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;

export const ContributionWrapper = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  align-content: center;
  width: fit-content;
  border-radius: ${spacing.threeEights};
  background-color: ${colors.grey1};
  padding: ${spacing.half} ${spacing.threeQuarter};
`;

export const ContributionCount = styled.div<ContributionCountProps>`
  ${heading3};
  color: ${({ campaignVariant }) =>
    ({
      [PerformantCampaignVariant.BEST]: colors.success100,
      [PerformantCampaignVariant.WORST]: colors.negative100,
    })[campaignVariant]};
`;

export const TooltipText = styled.div`
  ${caption}
  color: ${colors.textSecondary};
`;

export const ThumbnailWrapper = styled.div<ThumbnailWrapperProps>`
  display: flex;
  height: ${customSpacing.p48};
  width: ${customSpacing.p56};
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: ${spacing.eighth};
  border-radius: ${spacing.threeEights};
  border: ${spacing.single} solid ${colors.grey15};
  ${({ isThumbnailAvailable }) =>
    !isThumbnailAvailable
      ? {
          alignItems: 'center',
          background: colors.grey5,
          backgroundClip: 'content-box',
        }
      : {}}
`;

export const TitleText = styled.div`
  ${body1Bold};
`;

export const SubTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${customSpacing.p5};
`;

export const DeliveryCount = styled.span`
  ${body1};
`;

export const LinkWrapper = styled.div`
  display: flex;
  gap: ${spacing.threeQuarter};
  align-items: center;
`;

export const LinkText = styled(Link)`
  ${body1};
  text-decoration: underline;
  color: ${colors.link};
`;
